<template>
  <BaseModal
    title="Комментарии"
    align="right"
    :counter="comments.length || 0"
    @close="onCloseModal"
  >
    <div
      ref="modalBox"
      class="modal__box custom-scroll"
      :class="{'modal__box--has-scroll' : hasScroll}"
    >
      <div v-if="comments.length" class="column gap-xs">
        <CardComment
          v-for="item in comments"
          :key="item.id"
          :comment="item"
          is-modal-card
          collapsible
        />
      </div>
      <span v-else>Комментарии отсутствуют</span>
    </div>
  </BaseModal>
</template>

<script>
import CardComment from '@/components/production/CardComment.vue'
import BaseModal from '@/components/ui/Modal/BaseModal.vue'

export default {
  name: 'ModalComments',
  components: { BaseModal, CardComment },
  props: {
    comments: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    hasScroll: false,
    resizeObserver: null
  }),

  mounted () {
    this.$nextTick(() => {
      this.initResizeObserver()
      this.checkScroll()
    })
  },

  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },

  methods: {
    initResizeObserver () {
      const el = this.$refs.modalBox
      if (!el || this.resizeObserver) return

      this.resizeObserver = new ResizeObserver(() => {
        this.checkScroll()
      })

      this.resizeObserver.observe(el)
    },
    checkScroll () {
      const el = this.$refs.modalBox
      if (!el) return

      this.hasScroll = el.scrollHeight > el.clientHeight
    },

    onCloseModal () {
      this.hasScroll = false
      this.$emit('closeModal')
    }
  }
}
</script>
